export default __webpack_public_path__ + "static/media/sneakerIcon.db196ed2.png";